export default __webpack_public_path__ + "static/media/garden.7735422c.svg";